<div class="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-xl">
  <div>
    <h1 class="font-headline-lg text-headline-lg text-text-main dark:text-on-surface mb-1">Notifications</h1>
    @if (error()) {
      <p class="text-error font-body-sm text-body-sm">{{ error() }}</p>
    }
  </div>
</div>

<div class="bg-background dark:bg-surface-container-low border border-border-subtle dark:border-outline-variant rounded-xl p-md flex flex-wrap items-center gap-3 mb-gutter shadow-sm">
  <select [value]="technicianFilter() ?? ''" (change)="onTechnicianFilterChange($any($event.target).value)"
          class="bg-surface dark:bg-surface-container-highest border border-border-subtle dark:border-outline-variant rounded-lg px-3 py-2 text-body-sm h-[48px] text-text-main dark:text-white focus:outline-none focus:border-[#00B9F2] focus:ring-1 focus:ring-[#00B9F2]">
    <option value="">All Technicians</option>
    @for (tech of technicians(); track tech.technicianId) {
      <option [value]="tech.technicianId">{{ tech.firstName }} {{ tech.lastName }}</option>
    }
  </select>
  <label class="flex items-center gap-2 text-body-sm text-text-main dark:text-on-surface cursor-pointer">
    <input type="checkbox" [checked]="unreadOnly()" (change)="onUnreadOnlyChange($any($event.target).checked)"
           class="w-4 h-4 accent-[#00B9F2]">
    Unread only
  </label>
  <span class="text-text-muted dark:text-on-surface-variant font-label-sm ml-auto">{{ unreadCount() }} unread</span>
</div>

<div class="bg-background dark:bg-surface-container-low border border-border-subtle dark:border-outline-variant rounded-xl overflow-hidden shadow-sm">
  @if (loading()) {
    <p class="p-6 text-center text-text-muted dark:text-on-surface-variant font-body-sm">Loading notifications...</p>
  } @else if (notifications().length === 0) {
    <p class="p-6 text-center text-text-muted dark:text-on-surface-variant font-body-sm">No notifications found.</p>
  } @else {
    <div class="divide-y divide-border-subtle dark:divide-outline-variant">
      @for (notification of notifications(); track notification.notificationId) {
        <div class="p-4 flex items-start gap-3" [class.opacity-60]="notification.isRead">
          <span class="w-2 h-2 rounded-full mt-2 shrink-0" [style.background-color]="typeColor(notification.type)"></span>
          <div class="flex-1">
            <div class="flex items-center gap-2">
              <p class="font-label-md text-text-main dark:text-on-surface">{{ notification.technicianName || 'Unknown Technician' }}</p>
              @if (notification.jobId) {
                <span class="text-text-muted dark:text-on-surface-variant text-xs">Job #{{ notification.jobId }}</span>
              }
            </div>
            <p class="font-body-sm text-text-main dark:text-on-surface">{{ notification.message }}</p>
            <p class="text-text-muted dark:text-on-surface-variant text-xs">{{ notification.createdAt | date:'MMM d, y, h:mm a' }}</p>
          </div>
          @if (!notification.isRead) {
            <button (click)="markAsRead(notification)"
                    class="px-3 py-1.5 text-xs rounded-lg border border-[#00B9F2] text-[#00B9F2] hover:bg-[#00B9F2]/10 transition-colors font-label-sm shrink-0">
              Mark Read
            </button>
          }
        </div>
      }
    </div>
  }
</div>
